import React, { useState, useEffect } from "react"
import { DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import API from "../../Api/Api";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";

const DarkerDisabledTextField = withStyles({
    root: {
        marginRight: 8,
        "& .MuiInputBase-root.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.7)" // (default alpha is 0.38)
        }
    }
})(TextField);
function ProcessModal(props) {

    let api = new API();

    function modelClose() {
        props.handleModalClosed();
    }

    function getAPI() {
        return api.getProcessAPI();
    }

    function save(process) {
        getAPI().updateProcess(process).then(e => {
            props.setProcess(e.data);
            props.save(e.data);
            props.handleModalClosed();
        }).catch(e => {
            console.log("error", e);
        });
    }

    return (
        <Dialog
            maxWidth="md"
            open={props.open}
            onClose={props.handleModalClosed}
        >
            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <form>
                            <Grid container style={{ padding: "16px" }} spacing={3}>
                                <Grid item xs={11}>
                                    <Typography variant="h5" noWrap>
                                        Old Process {props.templateMode && 'Template'}
                                    </Typography>
                                       View this process.
                                         </Grid>

                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <DarkerDisabledTextField disabled label="Name" name="name" variant="outlined"
                                        value={props.beforeProcess.name}
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12}>
                                    <DarkerDisabledTextField disabled label="Description" name="description" variant="outlined"
                                        value={props.beforeProcess.description} multiline rows={3}
                                        fullWidth />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <Typography variant="h6">
                                        Hazards
                                    </Typography>
                                    <Typography>
                                        Identify and edit hazards belonging to this process.
                                     </Typography>
                                </Grid> */}

                                {/* <Grid item xs={12}>
                                    <HazardList
                                        process_pk={props.beforeProcess.pk}
                                        setHazardSelected={props.setHazardSelected}
                                        shouldUpdate={props.shouldUpdate}
                                        setShouldUpdate={props.setShouldUpdate}
                                    />
                                </Grid> */}

                            </Grid>
                        </form>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => save(props.beforeProcess)}
                        >
                            Revert
                        </Button>
                    </Grid>

                    <Grid item xs={6}>
                        <form>
                            <Grid container style={{ padding: "16px" }} spacing={3}>
                                <Grid item xs={11}>
                                    <Typography variant="h5" noWrap>
                                        Current Process {props.templateMode && 'Template'}
                                    </Typography>
                                       View this process.
                                         </Grid>

                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <DarkerDisabledTextField disabled label="Name" name="name" variant="outlined"
                                        value={props.oldProcess.name}
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12}>
                                    <DarkerDisabledTextField disabled label="Description" name="description" variant="outlined"
                                        value={props.oldProcess.description} multiline rows={3}
                                        fullWidth />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <Typography variant="h6">
                                        Hazards
                                    </Typography>
                                    <Typography>
                                        Identify and edit hazards belonging to this process.
                                     </Typography>
                                </Grid> */}

                                {/* <Grid item xs={12}>
                                    <HazardList
                                        process_pk={props.oldProcess.pk}
                                        setHazardSelected={props.setHazardSelected}
                                        shouldUpdate={props.shouldUpdate}
                                        setShouldUpdate={props.setShouldUpdate}
                                    />
                                </Grid> */}

                            </Grid>
                        </form>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={modelClose}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>

        </Dialog >
    )
}
export default ProcessModal;
